import gql from 'graphql-tag'
export const featureFlagQuery = () => gql`
  query featureFlags {
    featureFlags {
      feature
      enabled
      __typename
    }
  }
`
